import { SavedView } from '@sprint/sprint-react-components';
import DataGridRequest from './DataGridRequest';
export class TaskSavedViewsRequest extends DataGridRequest<SavedView> {
    Url = '/subscribers/lists/api/task';
}
